import React, { Fragment, Component } from 'react';
import './ConnectedCardComponent.css';

class ConnectedCard extends Component {

    constructor(props) {
        super(props);
    }

    handleThumbsUp = () => {
        this.props.sendMessage(this.props.text);
    }

    render() {
        return(
            <Fragment>
                <div className="connected">
                    {/* Image */}
                    <div className="img">
                        <span className="icon-success"><span className="icon-path1"></span><span className="icon-path2"></span><span className="icon-path3"></span></span>
                    </div>
                    {/* Text */}
                    <p>{this.props.text}</p>
                </div>
            </Fragment>
        )
    }

}

export default ConnectedCard;